module.exports = "<svg style=\"width: 14px; height: 16px\" viewBox=\"1 0 14 16\"><path d=\"M7.999,0 L1,4.001 L1,12.001 L7.999,16 L14.998,12.001 L15,4 L7.999,0 Z M4.046,4.563 L7.999,2.303 L11.953,4.562 L7.999,6.844 L4.046,4.563 Z M8.999,8.577 L12.999,6.268 L12.998,10.84 L8.999,13.126 L8.999,8.577 Z M3,10.84 L3,6.268 L6.999,8.578 L6.999,13.126 L3,10.84 Z\" id=\"path-1\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/box.svg
// module id = 1292
// module chunks = 0